// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"511":"b3990a8e","897":"26234c36"}[chunkId] + ".css";
};